import { Id64String } from "@itwin/core-bentley";
import { DecorateContext } from "@itwin/core-frontend";
import { Decorator } from "@itwin/core-frontend";
import { IModelApp } from "@itwin/core-frontend";
import { GraphicType } from "@itwin/core-frontend";
import { RenderGraphic } from "@itwin/core-frontend";
import { IModelConnection } from "@itwin/core-frontend";
import { readGltfGraphics } from "@itwin/core-frontend";
import { GraphicBranch } from "@itwin/core-frontend";
import { Point3d } from "@itwin/core-geometry";
import { Transform } from "@itwin/core-geometry";
import { RotateX, RotateY, RotateZ } from "../Helpers/DecoratorRotation";
/** A view decoration that draws a graphic created from a glTF asset. */
class GltfDecoration implements Decorator {
  /** A graphic created from a glTF asset. */
  private readonly _graphic: RenderGraphic;
  /** The tooltip to be displayed when the graphic is moused-over. */
  private readonly _tooltip: string;
  /** The Id of the graphic used for picking. */
  private readonly _pickableId: Id64String;

  public static activeConnection: IModelConnection;

  public constructor(
    graphic: RenderGraphic,
    tooltip: string,
    pickableId: Id64String
  ) {
    this._graphic = graphic;
    this._tooltip = tooltip;
    this._pickableId = pickableId;
  }

  /** Tell the display system not to recreate our graphics every time the mouse cursor moves. */
  public readonly useCachedDecorations = true;

  /** Draw our graphics into the viewport. */
  public decorate(context: DecorateContext): void {
    // Our graphics are defined in spatial coordinates so should only be drawn in a spatial view

    if (context.viewport.view.isSpatialView()) {
      // Produce a "scene" graphic so that it will be affected by lighting and other aspects of the viewport's display style.
      context.addDecoration(GraphicType.Scene, this._graphic);
    }
  }

  public getPickableId(): string {
    return this._pickableId;
  }

  /** Return true if the specified Id matches our graphic's pickable Id. */
  public testDecorationHit(id: string): boolean {
    return id === this._pickableId;
  }

  /** Provide a tooltip when our graphic is moused-over. */
  public async getDecorationToolTip(): Promise<string> {
    return this._tooltip;
  }
}

let iModel: IModelConnection;
let gltfModel = "latestCharger.glb";
let lookUpList: GltfDecoration[] = [];

export function setGltfModel(model: string) {
  gltfModel = model;
}

export function setIModel(iModelNew: IModelConnection) {
  iModel = iModelNew;
}

export async function placeGltfAsset(point: Point3d): Promise<boolean> {
  // Allow the user to select the glTF asset.

  let outerBuffer: ArrayBuffer;

    try {

        fetch('https://165.232.72.249:8080/' + gltfModel)
            .then(r => r.arrayBuffer())
            .then(async buffer => { // note this is already an ArrayBuffer
                // there is no buffer.data here

        outerBuffer = buffer;
        let graphic = await readGltfGraphics({
          gltf: new Uint8Array(outerBuffer),
          iModel,
        });

        if (!graphic) return false;
        point.z += 1;
        // Transform the graphic to the center of the project extents.
        let transform = Transform.createTranslation(point);

        transform = transform.multiplyTransformMatrix3d(
          RotateX(0.8 * Math.atan((point.z + 39) / point.y))
        );
        transform = transform.multiplyTransformMatrix3d(
          RotateY(1.4 * -Math.atan((point.z + 39) / point.x))
        );
        transform = transform.multiplyTransformMatrix3d(
          RotateZ(Math.atan(point.y / point.x))
        );
        point.z += 1;
        const branch = new GraphicBranch();
        branch.add(graphic);
        graphic = IModelApp.renderSystem.createGraphicBranch(branch, transform);

        // Take ownership of the graphic so that it is not disposed of until we're finished with it.
        // By doing so we take responsibility for disposing of it ourselves.
        const owner = IModelApp.renderSystem.createGraphicOwner(graphic);

        // Install the decorator, using the file name as the tooltip.
        const decorator = new GltfDecoration(owner, "", gltfModel);

        lookUpList.forEach((model) => {
          if (model.getPickableId() === gltfModel) {
            IModelApp.viewManager.dropDecorator(model);
          }
        });

        IModelApp.viewManager.addDecorator(decorator);
        lookUpList.push(decorator);

        // When the iModel is closed, dispose of the graphic and uninstall the decorator.
        iModel.onClose.addOnce(() => {
          owner.disposeGraphic();
          IModelApp.viewManager.dropDecorator(decorator);
        });
      });

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}
